<template>
  <b-row>
    <b-col
      v-for="(manager,index) in managers"
      :key="manager.id"
      :md="(index===(managers.length-1))?'12':'6'"
    >
      <manager-card
        :winner="index===0 && manager.total_original>0.1"
        :manager="manager"
        :query="query"
        :is-total="(index===(managers.length-1))"
      />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import ManagerCard from './ManagerCard'

export default {
  name: 'ManagerFinance',
  components: {
    ManagerCard,
    BRow,
    BCol,
  },
  props: {
    managers: {
      type: Array,
      default: () => [],
    },
    query: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style scoped>

</style>
